import React, { useState } from 'react';
import { Image, ImageWrapper } from './file-icon.styles';
import { FileIconProps } from './types';
import { IconFile } from '@shared/icon/icon-file/icon-file';
import { ICON_MAP } from './contants';

export const FileIcon: React.FC<FileIconProps> = ({ dimension, file }) => {
    const [isShowImage, setIsShowImage] = useState(Boolean(file.imageUrl));

    const handleLoadImageError = () => {
        setIsShowImage(false);
    };

    if (dimension === 'm') {
        return null;
    }

    if (isShowImage) {
        return (
            <ImageWrapper>
                <Image src={file.imageUrl} onError={handleLoadImageError} />
            </ImageWrapper>
        );
    }

    return ICON_MAP[file.extension] || <IconFile />;
};
